<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-info`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_540e2f516b__clip0_1381_75563)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.33334 7.99992C1.33334 4.31802 4.31811 1.33325 8.00001 1.33325C11.6819 1.33325 14.6667 4.31802 14.6667 7.99992C14.6667 11.6818 11.6819 14.6666 8.00001 14.6666C4.31811 14.6666 1.33334 11.6818 1.33334 7.99992ZM8.66668 5.99992V4.66659H7.33334V5.99992H8.66668ZM7.33334 6.66659V11.3333H8.66668V6.66659H7.33334Z"/></g><defs><clipPath id="svg_540e2f516b__clip0_1381_75563"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconFillInfo',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
